<template>
  <el-card v-loading="loading" class="em-product-picker">
    <el-select v-model="keyword" class="mb pr-md" value-key="skuid" placeholder="请输入关键词" :clearable="true" filterable style="width: 100%" @change="onSelectChange">
      <el-option-group v-for="product in productList" :key="product.productid" :label="product.title">
        <el-option v-for="sku in product.skus" :key="sku.skuid" :value="sku" :label="sku.skuTitle">
          <span v-overflow-tooltip class="ellipsis">{{ sku.skuTitle }}</span>
        </el-option>
      </el-option-group>
    </el-select>
    <el-scrollbar style="height: calc(100vh - 281px);">
      <el-collapse v-model="activeCollapse" :accordion="accordion">
        <el-collapse-item v-for="product in productList" :key="product.productid" :name="product.productid">
          <template slot="title">
            <span v-overflow-tooltip class="ellipsis"><b>{{ product.title }}</b></span>
            <span class="span text-muted ml-xs mr-xs">({{ product.skus.length }})</span>
          </template>
          <el-table :data="product.skus" :show-header="false" size="mini" @row-click="onTableRowClick">
            <el-table-column label="名称" min-width="200">
              <template slot-scope="scope">
                <div class="flex align-items-center">
                  <span v-overflow-tooltip class="ellipsis flex1" style="width: fit-content;">{{ scope.row.skuTitle }}</span>
                  <TierPricingDisplay v-if="scope.row.advanced_prices.length" :advanced_prices="scope.row.advanced_prices" />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-scrollbar>
  </el-card>
</template>

<script>
import { getGodProductListApi } from '@/api/ei/eiMallApi'
import TierPricingDisplay from './TierPricingDisplay'
export default {
  name: 'EmProductPicker',
  components: {
    TierPricingDisplay,
  },
  props: {
    // 开启手风琴模式
    accordion: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      keyword: '',
      activeCollapse: null,
      productList: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      getGodProductListApi()
        .then(res => {
          this.loading = false
          if (!res.errno) {
            res.data.list.forEach(item => {
              const index = this.productList.findIndex(v => v.productid === item.productid)
              const hasAttrs = item.attrs && item.attrs.length > 0
              const skuTitle = hasAttrs ? item.attrs.reduce((acc, cur) => {
                return acc + '；' + cur.attr_value
              }, item.title) : item.title
              const market_price = item.market_price < item.selling_price ? item.selling_price: item.market_price
              if (index > -1) {
                this.productList[index].skus.push({ ...item, market_price, customPrice: item.selling_price, skuTitle })
              } else {
                this.productList.push({
                  productid: item.productid,
                  title: item.title,
                  skus: [{ ...item, market_price, customPrice: item.selling_price, skuTitle }]
                })
              }
            })

          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },
    onSelectChange(product) {
      if (product) {
        this.selectProductSuccess(product)
      }
    },
    onTableRowClick(row) {
      this.selectProductSuccess(row)
    },
    selectProductSuccess(product) {
      this.$emit('success', product)
    }
  }
}
</script>

<style scoped lang="scss">
.em-product-picker {
  .el-collapse {
    .el-collapse-item {
      /deep/ .el-collapse-item__content {
        padding-bottom: 0;

        .el-table {
          .el-table__row {
            cursor: pointer;
            &:last-child {
              & > td {
                border-bottom: 0;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .el-card__body {
    padding-right: 0;
  }

  .el-scrollbar {
    /deep/ .el-scrollbar__wrap {
      padding-right: 20px;
    }
  }
}
</style>
